/*
 *
 * NewTreatmentPage constants
 *
 */
import {getPractice} from "utils/practiceStorage";

export const DEFAULT_ACTION = "app/NewTreatmentPage/DEFAULT_ACTION";

/**
 * Get end product
 */
export const GET_TREATMENT_PLAN = "app/NewTreatmentPage/GET_TREATMENT_PLAN";
export const GET_TREATMENT_PLAN_SUCCESS =
  "app/NewTreatmentPage/GET_TREATMENT_PLAN_SUCCESS";
export const GET_TREATMENT_PLAN_FAILED =
  "app/NewTreatmentPage/GET_TREATMENT_PLAN_FAILED";

/**
 * Create treatmentPlan
 */
export const CREATE_TREATMENT_PLAN =
  "app/NewTreatmentPage/CREATE_TREATMENT_PLAN";
export const CREATE_TREATMENT_PLAN_FAILED =
  "app/NewTreatmentPage/CREATE_TREATMENT_PLAN_FAILED";

export const CREATE_TREATMENT_PLAN_SUCCESS =
  "app/NewTreatmentPage/CREATE_TREATMENT_PLAN_SUCCESS";

/**
 * Update treatmentPlan
 */
export const UPDATE_TREATMENT_PLAN =
  "app/NewTreatmentPage/UPDATE_TREATMENT_PLAN";
export const UPDATE_TREATMENT_PLAN_FAILED =
  "app/NewTreatmentPage/UPDATE_TREATMENT_PLAN_FAILED";
export const UPDATE_TREATMENT_PLAN_SUCCESS =
  "app/NewTreatmentPage/UPDATE_TREATMENT_PLAN_SUCCESS";

/**
 * Get patient
 */
export const GET_PATIENT = "app/NewTreatmentPage/GET_PATIENT";
export const GET_PATIENT_FAILED = "app/NewTreatmentPage/GET_PATIENT_FAILED";
export const GET_PATIENT_SUCCESS = "app/NewTreatmentPage/GET_PATIENT_SUCCESS";

/**
 * Update patient
 */
export const UPDATE_PATIENT = "app/NewTreatmentPage/UPDATE_PATIENT";
export const UPDATE_PATIENT_FAILED =
  "app/NewTreatmentPage/UPDATE_PATIENT_FAILED";
export const UPDATE_PATIENT_SUCCESS =
  "app/NewTreatmentPage/UPDATE_PATIENT_SUCCESS";

/**
 * Delete planned treatment
 */
export const DELETE_PLANNED_TREATMENT =
  "app/NewTreatmentPage/DELETE_PLANNED_TREATMENT";
export const DELETE_PLANNED_TREATMENT_FAILED =
  "app/NewTreatmentPage/DELETE_PLANNED_TREATMENT_FAILED";
export const DELETE_PLANNED_TREATMENT_SUCCESS =
  "app/NewTreatmentPage/DELETE_PLANNED_TREATMENT_SUCCESS";

/**
 * Get patient by id
 */
export const GET_PATIENT_ID = "app/NewTreatmentPage/GET_PATIENT_ID";
export const GET_PATIENT_ID_SUCCESS =
  "app/NewTreatmentPage/GET_PATIENT_ID_SUCCESS";
export const GET_PATIENT_ID_FAILED =
  "app/NewTreatmentPage/GET_PATIENT_ID_FAILED";

/**
 * update treatmentPlan treatment
 */
export const UPDATE_TREATMENT_PLAN_TREATMENT =
  "app/NewTreatmentPage/UPDATE_TREATMENT_PLAN_TREATMENT";

/**
 * Get treatment plan by id
 */
export const GET_TREATMENT_PLAN_ID =
  "app/NewTreatmentPage/GET_TREATMENT_PLAN_ID";
export const GET_TREATMENT_PLAN_ID_SUCCESS =
  "app/NewTreatmentPage/GET_TREATMENT_PLAN_ID_SUCCESS";
export const GET_TREATMENT_PLAN_ID_FAILED =
  "app/NewTreatmentPage/GET_TREATMENT_PLAN_ID_FAILED";

/**
 * TimeSlotData
 */
export const GET_TIME_SLOT_DATA = "app/NewTreatmentPage/GET_TIME_SLOT_DATA";
export const GET_TIME_SLOT_DATA_FAILED =
  "app/NewTreatmentPage/GET_TIME_SLOT_DATA_FAILED";
export const GET_TIME_SLOT_DATA_SUCCESS =
  "app/NewTreatmentPage/GET_TIME_SLOT_DATA_SUCCESS";

/**
 * Set treatmentPlan
 */
export const SET_TREATMENT_PLAN = "app/NewTreatmentPage/SET_TREATMENT_PLAN";

/**
 * Editing status
 */
export const SET_EDITING_TREATMENT =
  "app/NewTreatmentPage/SET_EDITING_TREATMENT";

/**
 * Other
 */
export const IS_EDITING_PLANNED_TREATMENT =
  "app/NewTreatmentPage/IS_EDITING_PLANNED_TREATMENT";
export const SELECT_TIME_SLOT = "app/NewTreatmentPage/SELECT_TIME_SLOT";
export const TIME_WINDOW_ACTION = "app/NewTreatmentPage/TIME_WINDOW_ACTION";
export const SAVE_TREATMENTS = "app/NewTreatmentPage/SAVE_TREATMENTS";
export const SOFT_RESET = "app/NewTreatmentPage/SOFT_RESET";
export const HARD_RESET = "app/NewTreatmentPage/HARD_RESET";
export const CONTINUE = "app/NewTreatmentPage/CONTINUE";
export const SET_PATIENT = "app/NewTreatmentPage/SET_PATIENT";
export const REMOVE_PATIENT = "app/NewTreatmentPage/REMOVE_PATIENT";
export const SET_TREATMENT_TO_PLAN =
  "app/NewTreatmentPage/SET_TREATMENT_TO_PLAN";
export const SELECT_UNPLANNED = "app/NewTreatmentPage/SELECT_UNPLANNED";

export const CHECK_AVAILABILITY = "app/NewTreatmentPage/CHECK_AVAILABILITY";
export const CHECK_AVAILABILITY_FAILED =
  "app/NewTreatmentPage/CHECK_AVAILABILITY_FAILED";
export const CHECK_AVAILABILITY_SUCCESS =
  "app/NewTreatmentPage/CHECK_AVAILABILITY_SUCCESS";

export const GET_PLANNED_DAYS = "app/NewTreatmentPage/GET_PLANNED_DAYS";
export const GET_PLANNED_DAYS_SUCCESS =
  "app/NewTreatmentPage/GET_PLANNED_DAYS_SUCCESS";
export const GET_PLANNED_DAYS_ERROR =
  "app/NewTreatmentPage/GET_PLANNED_DAYS_ERROR";

export const GET_TREATMENT_DRIVERS =
  "app/NewTreatmentPage/GET_TREATMENT_DRIVERS";
export const GET_TREATMENT_DRIVERS_SUCCESS =
  "app/NewTreatmentPage/GET_TREATMENT_DRIVERS_SUCCESS";
export const GET_TREATMENT_DRIVERS_ERROR =
  "app/NewTreatmentPage/GET_TREATMENT_DRIVERS_ERROR";

export const GET_TREATMENT_DURATION =
  "app/NewTreatmentPage/GET_TREATMENT_DURATION";
export const GET_TREATMENT_DURATION_SUCCESS =
  "app/NewTreatmentPage/GET_TREATMENT_DURATION_SUCCESS";
export const GET_TREATMENT_DURATION_ERROR =
  "app/NewTreatmentPage/GET_TREATMENT_DURATION_ERROR";

/**
 * Urls
 */

export function CHECK_AVAILABILITY_URL() {
  return `/practices/${getPractice().id}/checkAvailability`;
}

export function TIME_SLOT_DATA_URL(timeSlotId) {
  return `/practices/${getPractice().id}/plannedTimeSlots/${timeSlotId}`;
}

export function PATIENT_ID_URL(patientId) {
  return `/practices/${getPractice().id}/patients/${patientId}`;
}

export function PATIENT_URL(patientId) {
  return `/practices/${getPractice().id}/patients/${patientId}`;
}

export function TREATMENT_PLAN_URL() {
  return `/practices/${getPractice().id}/patient/treatmentPlans`;
}

export function PLANNED_TREATMENTS_URL() {
  return `/practices/${getPractice().id}/plannedTreatments`;
}

export function PATIENTS_URL() {
  return `/practices/${getPractice().id}/patients`;
}

export function UPDATE_PATIENT_URL() {
  return `/practices/${getPractice().id}/patients`;
}

export function ACTIVE_TREATMENTS_URL(patientId) {
  return `/practices/${
    getPractice().id
  }/patient/${patientId}/treatmentPlans/active`;
}

export function TREATMENT_PLAN_ID_URL(treatmentPlanId) {
  return `/practices/${
    getPractice().id
  }/patient/treatmentPlans/${treatmentPlanId}`;
}

export function GET_PLANNED_DAYS_URL(date) {
  const formatted = date.format("YYYY-MM-DD");
  return `/practices/${getPractice().id}/plannedDay?date=${formatted}`;
}

export function TREATMENT_DURATION_URL(ptId, homeShipping) {
  return `/practices/${getPractice().id}/plannedTreatments/${ptId}/duration?homeShipping=${homeShipping}`;
}
